export function isCopayMaximizerProgramCheck(programs: string[]): boolean {
  for (const program of programs) {
    const lowerProgram = program.toLowerCase();
    if (lowerProgram.startsWith("capital rx/rx cap")
      || lowerProgram.startsWith("capital rx/copay maximizer")) {
      return true;
    }
  }
  return false;
};

export function isACAHIVPrEPRejectionCheck(rejectCodes: string[], programs: string[]): [boolean, null | string] {
  if (rejectCodes.length == 1 && rejectCodes[0] == "34") {
    for (const program of programs) {
      if (
        program == "capital rx/formulary/affordable care act/ACA HIV PrEP"
        || program == "capital rx/formulary/affordable care act/ACA HIV PrEP PA"
      ) {
        return [true, program];
      }
    }
  }
  return [false, null];
};
